const EVENTS_HELPER_TEXTS = {
    dateError: "PODANE DATY SĄ NIEPRAWIDŁOWE"
}

export default EVENTS_HELPER_TEXTS